<template>
  <div class="prize-box" v-if="!hasFinished || onEdit">
    <div class="prize-info">
      <ul>
        <li>
          <label class="sectit">获奖名称：</label>
          <div class="secon p-in">
            <el-input v-model="prizename" placeholder="请输入获奖名称" @focus="nameFocus"></el-input>
            <span class="err" v-if="nameErr">请填写获奖名称</span>
          </div>
        </li>
        <li>
          <div class="span2">
            <label class="sectit">获奖级别：</label>
            <div class="secon">
              <el-select  v-model="level" placeholder="请选择" @change="getLevel">
                <el-option v-for="(level, key) in levelObj" :key="key" :label="level" :value="key"></el-option>
              </el-select>
              <span class="err" v-if="levelErr">请选择获奖级别</span>
            </div>
          </div>
          <div class="span2">
            <label class="sectit">获奖等级：</label>
            <div class="secon">
              <el-select v-model="grade" placeholder="请选择" @change="getGrade">
                <el-option v-for="(level, key) in gradeObj" :key="key" :label="level" :value="key"></el-option>
              </el-select>
              <span class="err" v-if="gradeErr">请填写获奖等级</span>
            </div>
          </div>
        </li>
        <li>
          <div class="span2">
            <label class="sectit">颁奖单位：</label>
            <div class="secon">
              <el-input class="unit-in" v-model="unitname" placeholder="盖章单位" @focus="uintFocus"></el-input>
              <span class="err" v-if="unitErr">请填写颁奖单位</span>
            </div>
          </div>
          <div class="span2">
            <label class="sectit">获奖日期：</label>
            <div class="secon">
              <el-date-picker v-model="awardDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" @change="getDate"></el-date-picker>
              <span class="err" v-if="dateErr">请选择获奖日期</span>
            </div>
          </div>
        </li>
        <li class="pic-sec">
          <div class="title">证书照片：</div>
          <div class="pic-upload">
            <div class="unpic-box" v-if="!imgShow">
              <input type="file" class="unpic-input" ref="filePrize" @change="getFile">
            </div>
            <div class="pic-box" v-else>
              <img :src="imageUrl" alt="">
              <div class="delete" :class="imgShow ? 'delete-img' : ''" @click="deleteImg"></div>
            </div>
          </div>
          <span class="pic-err" v-if="imgErr" style="margin-left: 10px;">请上传证书照片</span>
        </li>
      </ul>
    </div>
    <div class="toggleInfo">
      <span @click="toggleLine(myIndex, 'add')" v-if="myIndex === 0">添加一行</span>
      <span @click="toggleLine(myIndex, 'delete')" v-else>删除本行</span>
    </div>
  </div>
  <div class="prize-box" v-else>
    <div class="prize-info">
      <ul>
        <li>
          <label class="sectit">获奖名称：</label>
          <div class="secon p-in">{{prizename}}</div>
        </li>
        <li>
          <label class="sectit">获奖级别：</label>
          <div class="secon">{{levelName}}</div>
        </li>
        <li>
          <label class="sectit">获奖等级：</label>
          <div class="secon">{{gradeName}}</div>
        </li>
        <li>
          <label class="sectit">颁奖单位：</label>
          <div class="secon">{{unitname}}</div>
        </li>
        <li>
          <label class="sectit">获奖日期：</label>
          <div class="secon">{{awardDate}}</div>
        </li>
        <li class="pic-sec">
          <div class="title">证书照片：</div>
          <div class="pic-upload">
            <div class="pic-box">
              <img :src="imageUrl" alt="">
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import api from '../../utils/api'
import config from '../../config'
export default {
  props: ['prizeDetail', 'myIndex', 'levelObj', 'gradeObj', 'aliClient', 'hasFinished', 'onEdit'],
  data () {
    return {
      prizename: '',
      nameErr: false,
      level: '',
      levelKey: '', // 获奖级别key
      levelName: '',
      levelErr: false,
      grade: '',
      gradeKey: '', // 获奖等级key
      gradeName: '',
      gradeErr: false,
      unitname: '',
      unitErr: false,
      awardDate: '',
      dateErr: false,
      imageUrl: '',
      imgErr: false,
      imgShow: false
    }
  },
  mounted () {
    if (this.prizeDetail) {
      this.prizename = this.prizeDetail.prizeTitle
      this.levelKey = this.prizeDetail.prizeLevel
      this.level = this.prizeDetail.prizeLevelName
      this.gradeKey = this.prizeDetail.grade
      this.grade = this.prizeDetail.gradeName
      this.unitname = this.prizeDetail.institution
      this.awardDate = this.prizeDetail.winTime
      this.imageUrl = this.prizeDetail.certImageUrl
      if (this.onEdit) {
        this.imgShow = true
      }
      for (let i in this.levelObj) {
        if (this.prizeDetail.prizeLevel === Number(i)) {
          this.levelName = this.levelObj[i]
        }
      }
      for (let k in this.gradeObj) {
        if (this.prizeDetail.grade === Number(k)) {
          this.gradeName = this.gradeObj[k]
        }
      }
    } else {
      // console.log('初始化')
    }

    this.usrId = window.sessionStorage.getItem('userId') ? window.sessionStorage.getItem('userId') : api.globalHeader.usrId
  },
  methods: {
    toggleLine (index, type) {
      if (type === 'add') {
        this.$parent.addPrize()
      } else {
        this.$emit('deletePrize', index)
      }
    },
    nameFocus () {
      this.nameErr = false
    },
    getLevel (val) {
      this.levelKey = Number(val)
      for (let i in this.levelObj) {
        if (val === i) {
          this.levelName = this.levelObj[i]
        }
      }
      this.levelErr = false
    },
    getGrade (val) {
      this.gradeKey = Number(val)
      for (let i in this.gradeObj) {
        if (val === i) {
          this.gradeName = this.gradeObj[i]
        }
      }
      this.gradeErr = false
    },
    uintFocus () {
      this.unitErr = false
    },
    getDate () {
      this.dateErr = false
    },
    prizeSubmit () {
      // 全部填写或全部不填写
      if (this.prizename !== '' || this.level !== '' || this.grade !== '' || this.unitname !== '' || this.awardDate !== '' || this.imageUrl !== '') {
        if (this.prizename === '') {
          this.nameErr = true
          return false
        }
        if (this.level === '') {
          this.levelErr = true
          return false
        }
        if (this.grade === '') {
          this.gradeErr = true
          return false
        }
        if (this.unitname === '') {
          this.unitErr = true
          return false
        }
        if (this.awardDate === '') {
          this.dateErr = true
          return false
        }
        if (this.imageUrl === '') {
          this.imgErr = true
          return false
        }
        let prizeObj = {
          prizeTitle: this.prizename,
          grade: parseInt(this.gradeKey),
          prizeLevel: parseInt(this.levelKey),
          institution: this.unitname,
          winTime: this.awardDate,
          certImageUrl: this.setUrlpath(this.imageUrl)
        }
        let prizeNameObj = {
          prizeTitle: this.prizename,
          grade: parseInt(this.gradeKey),
          gradeName: this.gradeName,
          prizeLevelName: this.levelName,
          prizeLevel: parseInt(this.levelKey),
          institution: this.unitname,
          winTime: this.awardDate,
          certImageUrl: this.imageUrl
        }
        this.$emit('prizeResult', [prizeObj, prizeNameObj])
        return true
      } else {
        this.nameErr = false
        this.levelErr = false
        this.gradeErr = false
        this.unitErr = false
        this.dateErr = false
        this.imgErr = false
        this.$emit('prizeResult', 0)
        return true
      }
    },
    // 上传图片
    getFile () {
      let _this = this
      let inputFile = _this.$refs.filePrize.files[0]
      let storeAs = 'szteacher-img/' + _this.usrId + '/' + _this.getObjKey(inputFile)
      if (inputFile) {
        if (inputFile.type !== 'image/jpeg' && inputFile.type !== 'image/png' && inputFile.type !== 'image/gif') {
          _this.$message({
            message: '不是有效的图片文件！',
            type: 'error'
          })
          return false
        }
        _this.aliClient.multipartUpload(storeAs, inputFile).then(function (result) {
          if (result.res.status === 200) {
            _this.$message({
              message: '上传成功',
              type: 'success'
            })
            _this.imageUrl = config.imgCdnHost + result.name
            _this.imgShow = true
            _this.imgErr = false
          } else {
            _this.$message({
              message: '上传失败，请重试',
              type: 'error'
            })
          }
        }).catch(function (err) {
          _this.$message({
            message: '上传失败，请重试',
            type: 'error'
          })
        })
      } else {
        return false
      }
    },
    // 组装图片名称
    getObjKey (fileObj) {
      let objKey = this.getUuid() + '.' + fileObj.name.split('.')[fileObj.name.split('.').length - 1]
      return objKey
    },
    // 截取url字符串域名后面的部分
    setUrlpath (url) {
      let urlPath = new URL(url).pathname
      return urlPath.substr(urlPath.indexOf('/') + 1, urlPath.length - 1)
    },
    // 生成uuid
    getUuid () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = Math.random() * 16 | 0
        let v = c === 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    },
    // 删除图片
    deleteImg () {
      this.imgShow = false
      this.imageUrl = ''
    }
  },
  watch: {
    levelObj (val) {
      // console.log(val)
      this.levelObj = val
    },
    gradeObj (gval) {
      this.gradeObj = gval
      // console.log(gval)
    },
    aliClient (val) {
      // console.log(val)
    },
    onEdit (val) {
      if (this.imageUrl !== '') {
        this.imgShow = true
      } else {
        this.imgShow = false
      }
    }
  }
}
</script>
<style scoped>
  .prize-box li {
    display: flex;
    align-items: center;
    padding-bottom: 20px;
  }

  .prize-box li.pic-sec {
    align-items: flex-start;
    justify-content: flex-start;
  }

  .prize-box li.pic-sec .title {
    width: 70px;
  }

  .prize-box li .p-in {
    flex: 1;
  }

  .prize-box li .sectit {
    font-size: 14px;
    width: 70px;
    color: #333;
  }

  .prize-box li .secon {
    position: relative;
    font-size: 14px;
  }

  .prize-box li .secon .err {
    position: absolute;
    left: 0;
    top: 40px;
    color: #ff0000;
    font-size: 12px;
  }

  .prize-box li .pic-err {
    color: #ff0000;
    font-size: 12px;
  }

  .prize-box li .span2 {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .prize-box li .span2:first-child {
    margin-right: 25px;
  }

  .prize-box li .el-select {
    width: 185px;
  }

  .prize-box li .span2 .unit-in, .prize-box li .span2 .el-date-editor {
    width: 185px;
  }

  .prize-box li .title {
    width: 100%;
    font-size: 14px;
  }

  .toggleInfo {
    color: #008fe6;
    font-size: 12px;
    text-align: right;
  }

  .toggleInfo span {
    cursor: pointer;
  }

  .unpic-box {
    position: relative;
    width: 120px;
    height: 120px;
    background: #fff url('../../assets/add_icon.png') center center no-repeat;
    background-size: 32px 32px;
    border: 1px dashed #ccc;
    border-radius: 5px;
  }

  .unpic-box .unpic-input {
    position: absolute;
    top: 0;
    left: 0;
    width: 120px;
    height: 120px;
    opacity: 0;
    z-index: 1;
  }

  .pic-box {
    position: relative;
    width: 120px;
    height: 120px;
    border: 1px dashed #ccc;
    border-radius: 5px;
    background: #fff;
  }

  .pic-box img {
    width: 120px;
    max-height: 120px;
  }

  .pic-box .delete-img {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 120px;
    height: 120px;
    z-index: 1;
    border-radius: 5px;
    background: rgba(0, 0, 0, 0.5) url('../../assets/delete.png') center center no-repeat;
    background-size: 32px 32px;
    cursor: pointer;
  }

  .pic-box:hover .delete {
    display: block;
  }
</style>
